import { Module } from 'wrapper6'
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

const $ = jQuery

export default class ProductsSlider extends Module {
  ready (app) {
    this.productsSliders = document.querySelectorAll('.mtt-products-slider')

    if (this.productsSliders.length) {
      for (let i = 0; i < this.productsSliders.length; i++) {
        const sliderWrapper = this.productsSliders[i]

        new ProductSlider(sliderWrapper)
      }
    }
  }
}

class ProductSlider {
  constructor (sliderWrapper) {
    this.sliderWrapper = sliderWrapper
    this.addSlider()
  }

  addSlider () {
    this.slider = this.sliderWrapper.querySelector('.swiper-container')

    const nextArrow = this.sliderWrapper.querySelector('.mtt-swiper-button-next')
    const prevArrow = this.sliderWrapper.querySelector('.mtt-swiper-button-prev')

    new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: 24,
      watchOverflow: true,
      lazy: {
        loadPrevNext: true,
        checkInView: false
      },
      watchSlidesVisibility: true,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow
      },
      breakpoints: {
        580: {
          slidesPerView: 2
        },
        900: {
          slidesPerView: 3
        }
      }
    })
  }
}
